import type { Action } from 'redux'
import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../signalr/helpers'
import type { InvokeDefinition, StreamDefinition } from '../../signalr/types'
import {
  type SetUserPreferencesAction,
  fetchUserPreferencesSuccess,
  setUserPreferencesFailure,
  setUserPreferencesSuccess
} from './actions'
import type { UserPreferences } from './type'

export const fetchUserPreferencesDefinition: StreamDefinition<
  [],
  UserPreferences,
  Action
> = {
  method: 'GetUserPreferences',
  strategy: 'merge',
  getParams,
  mapResponse: fetchUserPreferencesSuccess,
  errorAction: 'userPreferences.fetchUserPreferencesFailure',
  cancelOn: []
}

export const saveUserPreferencesDefinition: InvokeDefinition<
  [UserPreferences],
  any,
  SetUserPreferencesAction
> = {
  method: 'SetUserPreferences',
  getParams: payloadAsParam,
  mapResponse: (response, action) =>
    setUserPreferencesSuccess(action.payload, response),
  mapError: setUserPreferencesFailure
}
